// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file workqueue/v1/workqueue.proto (package workqueue.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file workqueue/v1/workqueue.proto.
 */
export const file_workqueue_v1_workqueue: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * WorkItem is a single unit of work in the queue.
 *
 * @generated from message workqueue.v1.WorkItem
 */
export type WorkItem = Message<"workqueue.v1.WorkItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: map<string, string> tags = 4;
   */
  tags: { [key: string]: string };

  /**
   * @generated from field: map<string, string> context = 5;
   */
  context: { [key: string]: string };

  /**
   * @generated from field: string source_ref = 6;
   */
  sourceRef: string;

  /**
   * @generated from field: string claimed_by = 7;
   */
  claimedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp claimed_at = 8;
   */
  claimedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp due_at = 11;
   */
  dueAt?: Timestamp | undefined;
};

/**
 * Describes the message workqueue.v1.WorkItem.
 * Use `create(WorkItemSchema)` to create a new message.
 */
export const WorkItemSchema: GenMessage<WorkItem> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 0);

/**
 * @generated from message workqueue.v1.CreateWorkItemRequest
 */
export type CreateWorkItemRequest = Message<"workqueue.v1.CreateWorkItemRequest"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: map<string, string> tags = 2;
   */
  tags: { [key: string]: string };

  /**
   * @generated from field: map<string, string> context = 3;
   */
  context: { [key: string]: string };

  /**
   * @generated from field: string source_ref = 4;
   */
  sourceRef: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_at = 5;
   */
  dueAt?: Timestamp | undefined;
};

/**
 * Describes the message workqueue.v1.CreateWorkItemRequest.
 * Use `create(CreateWorkItemRequestSchema)` to create a new message.
 */
export const CreateWorkItemRequestSchema: GenMessage<CreateWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 1);

/**
 * @generated from message workqueue.v1.CreateWorkItemResponse
 */
export type CreateWorkItemResponse = Message<"workqueue.v1.CreateWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;

  /**
   * created is true if a new item was created, false if an existing item
   * was returned due to source_ref deduplication.
   *
   * @generated from field: bool created = 2;
   */
  created: boolean;
};

/**
 * Describes the message workqueue.v1.CreateWorkItemResponse.
 * Use `create(CreateWorkItemResponseSchema)` to create a new message.
 */
export const CreateWorkItemResponseSchema: GenMessage<CreateWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 2);

/**
 * @generated from message workqueue.v1.GetWorkItemRequest
 */
export type GetWorkItemRequest = Message<"workqueue.v1.GetWorkItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message workqueue.v1.GetWorkItemRequest.
 * Use `create(GetWorkItemRequestSchema)` to create a new message.
 */
export const GetWorkItemRequestSchema: GenMessage<GetWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 3);

/**
 * @generated from message workqueue.v1.GetWorkItemResponse
 */
export type GetWorkItemResponse = Message<"workqueue.v1.GetWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.GetWorkItemResponse.
 * Use `create(GetWorkItemResponseSchema)` to create a new message.
 */
export const GetWorkItemResponseSchema: GenMessage<GetWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 4);

/**
 * @generated from message workqueue.v1.ListWorkItemsRequest
 */
export type ListWorkItemsRequest = Message<"workqueue.v1.ListWorkItemsRequest"> & {
  /**
   * Filter criteria (all optional, combined with AND).
   *
   * @generated from field: repeated string statuses = 1;
   */
  statuses: string[];

  /**
   * @generated from field: repeated string types = 2;
   */
  types: string[];

  /**
   * @generated from field: map<string, string> tags = 3;
   */
  tags: { [key: string]: string };

  /**
   * @generated from field: string claimed_by = 4;
   */
  claimedBy: string;

  /**
   * Date range filters.
   *
   * @generated from field: google.protobuf.Timestamp created_after = 5;
   */
  createdAfter?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_before = 6;
   */
  createdBefore?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp due_before = 7;
   */
  dueBefore?: Timestamp | undefined;

  /**
   * Pagination.
   *
   * @generated from field: int32 page_size = 10;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 11;
   */
  pageToken: string;

  /**
   * Sort order. Default: priority desc, created_at asc.
   *
   * @generated from field: string sort_by = 12;
   */
  sortBy: string;

  /**
   * @generated from field: bool sort_desc = 13;
   */
  sortDesc: boolean;
};

/**
 * Describes the message workqueue.v1.ListWorkItemsRequest.
 * Use `create(ListWorkItemsRequestSchema)` to create a new message.
 */
export const ListWorkItemsRequestSchema: GenMessage<ListWorkItemsRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 5);

/**
 * @generated from message workqueue.v1.ListWorkItemsResponse
 */
export type ListWorkItemsResponse = Message<"workqueue.v1.ListWorkItemsResponse"> & {
  /**
   * @generated from field: repeated workqueue.v1.WorkItem items = 1;
   */
  items: WorkItem[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message workqueue.v1.ListWorkItemsResponse.
 * Use `create(ListWorkItemsResponseSchema)` to create a new message.
 */
export const ListWorkItemsResponseSchema: GenMessage<ListWorkItemsResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 6);

/**
 * @generated from message workqueue.v1.UpdateWorkItemRequest
 */
export type UpdateWorkItemRequest = Message<"workqueue.v1.UpdateWorkItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Fields to update (merged with existing values).
   *
   * @generated from field: map<string, string> tags = 2;
   */
  tags: { [key: string]: string };

  /**
   * @generated from field: map<string, string> context = 3;
   */
  context: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp due_at = 4;
   */
  dueAt?: Timestamp | undefined;
};

/**
 * Describes the message workqueue.v1.UpdateWorkItemRequest.
 * Use `create(UpdateWorkItemRequestSchema)` to create a new message.
 */
export const UpdateWorkItemRequestSchema: GenMessage<UpdateWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 7);

/**
 * @generated from message workqueue.v1.UpdateWorkItemResponse
 */
export type UpdateWorkItemResponse = Message<"workqueue.v1.UpdateWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.UpdateWorkItemResponse.
 * Use `create(UpdateWorkItemResponseSchema)` to create a new message.
 */
export const UpdateWorkItemResponseSchema: GenMessage<UpdateWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 8);

/**
 * @generated from message workqueue.v1.DeleteWorkItemRequest
 */
export type DeleteWorkItemRequest = Message<"workqueue.v1.DeleteWorkItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message workqueue.v1.DeleteWorkItemRequest.
 * Use `create(DeleteWorkItemRequestSchema)` to create a new message.
 */
export const DeleteWorkItemRequestSchema: GenMessage<DeleteWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 9);

/**
 * @generated from message workqueue.v1.DeleteWorkItemResponse
 */
export type DeleteWorkItemResponse = Message<"workqueue.v1.DeleteWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.DeleteWorkItemResponse.
 * Use `create(DeleteWorkItemResponseSchema)` to create a new message.
 */
export const DeleteWorkItemResponseSchema: GenMessage<DeleteWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 10);

/**
 * @generated from message workqueue.v1.ClaimWorkItemRequest
 */
export type ClaimWorkItemRequest = Message<"workqueue.v1.ClaimWorkItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message workqueue.v1.ClaimWorkItemRequest.
 * Use `create(ClaimWorkItemRequestSchema)` to create a new message.
 */
export const ClaimWorkItemRequestSchema: GenMessage<ClaimWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 11);

/**
 * @generated from message workqueue.v1.ClaimWorkItemResponse
 */
export type ClaimWorkItemResponse = Message<"workqueue.v1.ClaimWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.ClaimWorkItemResponse.
 * Use `create(ClaimWorkItemResponseSchema)` to create a new message.
 */
export const ClaimWorkItemResponseSchema: GenMessage<ClaimWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 12);

/**
 * @generated from message workqueue.v1.ReleaseWorkItemRequest
 */
export type ReleaseWorkItemRequest = Message<"workqueue.v1.ReleaseWorkItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message workqueue.v1.ReleaseWorkItemRequest.
 * Use `create(ReleaseWorkItemRequestSchema)` to create a new message.
 */
export const ReleaseWorkItemRequestSchema: GenMessage<ReleaseWorkItemRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 13);

/**
 * @generated from message workqueue.v1.ReleaseWorkItemResponse
 */
export type ReleaseWorkItemResponse = Message<"workqueue.v1.ReleaseWorkItemResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.ReleaseWorkItemResponse.
 * Use `create(ReleaseWorkItemResponseSchema)` to create a new message.
 */
export const ReleaseWorkItemResponseSchema: GenMessage<ReleaseWorkItemResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 14);

/**
 * @generated from message workqueue.v1.TransitionStatusRequest
 */
export type TransitionStatusRequest = Message<"workqueue.v1.TransitionStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string new_status = 2;
   */
  newStatus: string;
};

/**
 * Describes the message workqueue.v1.TransitionStatusRequest.
 * Use `create(TransitionStatusRequestSchema)` to create a new message.
 */
export const TransitionStatusRequestSchema: GenMessage<TransitionStatusRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 15);

/**
 * @generated from message workqueue.v1.TransitionStatusResponse
 */
export type TransitionStatusResponse = Message<"workqueue.v1.TransitionStatusResponse"> & {
  /**
   * @generated from field: workqueue.v1.WorkItem item = 1;
   */
  item?: WorkItem | undefined;
};

/**
 * Describes the message workqueue.v1.TransitionStatusResponse.
 * Use `create(TransitionStatusResponseSchema)` to create a new message.
 */
export const TransitionStatusResponseSchema: GenMessage<TransitionStatusResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 16);

/**
 * @generated from message workqueue.v1.AddNoteRequest
 */
export type AddNoteRequest = Message<"workqueue.v1.AddNoteRequest"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message workqueue.v1.AddNoteRequest.
 * Use `create(AddNoteRequestSchema)` to create a new message.
 */
export const AddNoteRequestSchema: GenMessage<AddNoteRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 17);

/**
 * @generated from message workqueue.v1.AddNoteResponse
 */
export type AddNoteResponse = Message<"workqueue.v1.AddNoteResponse"> & {
};

/**
 * Describes the message workqueue.v1.AddNoteResponse.
 * Use `create(AddNoteResponseSchema)` to create a new message.
 */
export const AddNoteResponseSchema: GenMessage<AddNoteResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 18);

/**
 * @generated from message workqueue.v1.LogTimeRequest
 */
export type LogTimeRequest = Message<"workqueue.v1.LogTimeRequest"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp | undefined;
};

/**
 * Describes the message workqueue.v1.LogTimeRequest.
 * Use `create(LogTimeRequestSchema)` to create a new message.
 */
export const LogTimeRequestSchema: GenMessage<LogTimeRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 19);

/**
 * @generated from message workqueue.v1.LogTimeResponse
 */
export type LogTimeResponse = Message<"workqueue.v1.LogTimeResponse"> & {
};

/**
 * Describes the message workqueue.v1.LogTimeResponse.
 * Use `create(LogTimeResponseSchema)` to create a new message.
 */
export const LogTimeResponseSchema: GenMessage<LogTimeResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 20);

/**
 * @generated from message workqueue.v1.StatusLifecycle
 */
export type StatusLifecycle = Message<"workqueue.v1.StatusLifecycle"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: repeated string statuses = 2;
   */
  statuses: string[];

  /**
   * @generated from field: map<string, workqueue.v1.StatusTransitions> transitions = 3;
   */
  transitions: { [key: string]: StatusTransitions };

  /**
   * @generated from field: string initial_status = 4;
   */
  initialStatus: string;

  /**
   * @generated from field: repeated string terminal_statuses = 5;
   */
  terminalStatuses: string[];
};

/**
 * Describes the message workqueue.v1.StatusLifecycle.
 * Use `create(StatusLifecycleSchema)` to create a new message.
 */
export const StatusLifecycleSchema: GenMessage<StatusLifecycle> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 21);

/**
 * StatusTransitions holds the list of allowed next statuses for a given status.
 *
 * @generated from message workqueue.v1.StatusTransitions
 */
export type StatusTransitions = Message<"workqueue.v1.StatusTransitions"> & {
  /**
   * @generated from field: repeated string targets = 1;
   */
  targets: string[];
};

/**
 * Describes the message workqueue.v1.StatusTransitions.
 * Use `create(StatusTransitionsSchema)` to create a new message.
 */
export const StatusTransitionsSchema: GenMessage<StatusTransitions> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 22);

/**
 * @generated from message workqueue.v1.GetLifecycleRequest
 */
export type GetLifecycleRequest = Message<"workqueue.v1.GetLifecycleRequest"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;
};

/**
 * Describes the message workqueue.v1.GetLifecycleRequest.
 * Use `create(GetLifecycleRequestSchema)` to create a new message.
 */
export const GetLifecycleRequestSchema: GenMessage<GetLifecycleRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 23);

/**
 * @generated from message workqueue.v1.GetLifecycleResponse
 */
export type GetLifecycleResponse = Message<"workqueue.v1.GetLifecycleResponse"> & {
  /**
   * @generated from field: workqueue.v1.StatusLifecycle lifecycle = 1;
   */
  lifecycle?: StatusLifecycle | undefined;
};

/**
 * Describes the message workqueue.v1.GetLifecycleResponse.
 * Use `create(GetLifecycleResponseSchema)` to create a new message.
 */
export const GetLifecycleResponseSchema: GenMessage<GetLifecycleResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 24);

/**
 * @generated from message workqueue.v1.SetLifecycleRequest
 */
export type SetLifecycleRequest = Message<"workqueue.v1.SetLifecycleRequest"> & {
  /**
   * @generated from field: workqueue.v1.StatusLifecycle lifecycle = 1;
   */
  lifecycle?: StatusLifecycle | undefined;
};

/**
 * Describes the message workqueue.v1.SetLifecycleRequest.
 * Use `create(SetLifecycleRequestSchema)` to create a new message.
 */
export const SetLifecycleRequestSchema: GenMessage<SetLifecycleRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 25);

/**
 * @generated from message workqueue.v1.SetLifecycleResponse
 */
export type SetLifecycleResponse = Message<"workqueue.v1.SetLifecycleResponse"> & {
  /**
   * @generated from field: workqueue.v1.StatusLifecycle lifecycle = 1;
   */
  lifecycle?: StatusLifecycle | undefined;
};

/**
 * Describes the message workqueue.v1.SetLifecycleResponse.
 * Use `create(SetLifecycleResponseSchema)` to create a new message.
 */
export const SetLifecycleResponseSchema: GenMessage<SetLifecycleResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 26);

/**
 * @generated from message workqueue.v1.ListLifecyclesRequest
 */
export type ListLifecyclesRequest = Message<"workqueue.v1.ListLifecyclesRequest"> & {
};

/**
 * Describes the message workqueue.v1.ListLifecyclesRequest.
 * Use `create(ListLifecyclesRequestSchema)` to create a new message.
 */
export const ListLifecyclesRequestSchema: GenMessage<ListLifecyclesRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 27);

/**
 * @generated from message workqueue.v1.ListLifecyclesResponse
 */
export type ListLifecyclesResponse = Message<"workqueue.v1.ListLifecyclesResponse"> & {
  /**
   * @generated from field: repeated workqueue.v1.StatusLifecycle lifecycles = 1;
   */
  lifecycles: StatusLifecycle[];
};

/**
 * Describes the message workqueue.v1.ListLifecyclesResponse.
 * Use `create(ListLifecyclesResponseSchema)` to create a new message.
 */
export const ListLifecyclesResponseSchema: GenMessage<ListLifecyclesResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 28);

/**
 * @generated from message workqueue.v1.GetQueueStatsRequest
 */
export type GetQueueStatsRequest = Message<"workqueue.v1.GetQueueStatsRequest"> & {
  /**
   * Optional filters to scope the stats.
   *
   * @generated from field: repeated string types = 1;
   */
  types: string[];

  /**
   * @generated from field: map<string, string> tags = 2;
   */
  tags: { [key: string]: string };
};

/**
 * Describes the message workqueue.v1.GetQueueStatsRequest.
 * Use `create(GetQueueStatsRequestSchema)` to create a new message.
 */
export const GetQueueStatsRequestSchema: GenMessage<GetQueueStatsRequest> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 29);

/**
 * @generated from message workqueue.v1.GetQueueStatsResponse
 */
export type GetQueueStatsResponse = Message<"workqueue.v1.GetQueueStatsResponse"> & {
  /**
   * @generated from field: workqueue.v1.QueueStats stats = 1;
   */
  stats?: QueueStats | undefined;
};

/**
 * Describes the message workqueue.v1.GetQueueStatsResponse.
 * Use `create(GetQueueStatsResponseSchema)` to create a new message.
 */
export const GetQueueStatsResponseSchema: GenMessage<GetQueueStatsResponse> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 30);

/**
 * @generated from message workqueue.v1.QueueStats
 */
export type QueueStats = Message<"workqueue.v1.QueueStats"> & {
  /**
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * @generated from field: map<string, int32> by_status = 2;
   */
  byStatus: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> by_type = 3;
   */
  byType: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> by_priority = 4;
   */
  byPriority: { [key: string]: number };

  /**
   * @generated from field: int32 overdue = 5;
   */
  overdue: number;

  /**
   * @generated from field: int32 unassigned = 6;
   */
  unassigned: number;
};

/**
 * Describes the message workqueue.v1.QueueStats.
 * Use `create(QueueStatsSchema)` to create a new message.
 */
export const QueueStatsSchema: GenMessage<QueueStats> = /*@__PURE__*/
  messageDesc(file_workqueue_v1_workqueue, 31);

/**
 * WorkQueueService manages work items with configurable status lifecycles.
 *
 * @generated from service workqueue.v1.WorkQueueService
 */
export const WorkQueueService: GenService<{
  /**
   * CreateWorkItem creates a new work item. Idempotent on source_ref.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.CreateWorkItem
   */
  createWorkItem: {
    methodKind: "unary";
    input: typeof CreateWorkItemRequestSchema;
    output: typeof CreateWorkItemResponseSchema;
  },
  /**
   * GetWorkItem retrieves a work item by ID.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.GetWorkItem
   */
  getWorkItem: {
    methodKind: "unary";
    input: typeof GetWorkItemRequestSchema;
    output: typeof GetWorkItemResponseSchema;
  },
  /**
   * ListWorkItems returns a filtered, paginated list of work items.
   * Server applies authorization triples to filter results.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.ListWorkItems
   */
  listWorkItems: {
    methodKind: "unary";
    input: typeof ListWorkItemsRequestSchema;
    output: typeof ListWorkItemsResponseSchema;
  },
  /**
   * UpdateWorkItem updates tags, context, or metadata on a work item.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.UpdateWorkItem
   */
  updateWorkItem: {
    methodKind: "unary";
    input: typeof UpdateWorkItemRequestSchema;
    output: typeof UpdateWorkItemResponseSchema;
  },
  /**
   * DeleteWorkItem transitions a work item to cancelled status.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.DeleteWorkItem
   */
  deleteWorkItem: {
    methodKind: "unary";
    input: typeof DeleteWorkItemRequestSchema;
    output: typeof DeleteWorkItemResponseSchema;
  },
  /**
   * ClaimWorkItem takes ownership of a work item.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.ClaimWorkItem
   */
  claimWorkItem: {
    methodKind: "unary";
    input: typeof ClaimWorkItemRequestSchema;
    output: typeof ClaimWorkItemResponseSchema;
  },
  /**
   * ReleaseWorkItem releases ownership of a work item.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.ReleaseWorkItem
   */
  releaseWorkItem: {
    methodKind: "unary";
    input: typeof ReleaseWorkItemRequestSchema;
    output: typeof ReleaseWorkItemResponseSchema;
  },
  /**
   * TransitionStatus moves an item to a new status (validated against lifecycle).
   *
   * @generated from rpc workqueue.v1.WorkQueueService.TransitionStatus
   */
  transitionStatus: {
    methodKind: "unary";
    input: typeof TransitionStatusRequestSchema;
    output: typeof TransitionStatusResponseSchema;
  },
  /**
   * AddNote adds a note to a work item's activity log.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.AddNote
   */
  addNote: {
    methodKind: "unary";
    input: typeof AddNoteRequestSchema;
    output: typeof AddNoteResponseSchema;
  },
  /**
   * LogTime records a start/stop time entry on a work item.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.LogTime
   */
  logTime: {
    methodKind: "unary";
    input: typeof LogTimeRequestSchema;
    output: typeof LogTimeResponseSchema;
  },
  /**
   * GetLifecycle retrieves the status lifecycle for a work item type.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.GetLifecycle
   */
  getLifecycle: {
    methodKind: "unary";
    input: typeof GetLifecycleRequestSchema;
    output: typeof GetLifecycleResponseSchema;
  },
  /**
   * SetLifecycle creates or updates a lifecycle definition for a type.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.SetLifecycle
   */
  setLifecycle: {
    methodKind: "unary";
    input: typeof SetLifecycleRequestSchema;
    output: typeof SetLifecycleResponseSchema;
  },
  /**
   * ListLifecycles lists all configured type lifecycles.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.ListLifecycles
   */
  listLifecycles: {
    methodKind: "unary";
    input: typeof ListLifecyclesRequestSchema;
    output: typeof ListLifecyclesResponseSchema;
  },
  /**
   * GetQueueStats returns aggregate counts for the user's visible items.
   *
   * @generated from rpc workqueue.v1.WorkQueueService.GetQueueStats
   */
  getQueueStats: {
    methodKind: "unary";
    input: typeof GetQueueStatsRequestSchema;
    output: typeof GetQueueStatsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_workqueue_v1_workqueue, 0);

